// Bridges the simplified React customer workspace to the existing Print Pack module
// without mutating React-owned DOM. A temporary hidden legacy drawer is mounted
// outside the React root so the existing Print Pack injector can resolve the customer.

let busy = false;

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

const openPack = async detail => {
  if (busy) return;
  busy = true;
  const customer = detail?.customer || {};
  const mode = detail?.mode || 'print';
  const host = document.createElement('div');
  host.className = 'vc-opportunity-drawer';
  host.setAttribute('aria-hidden','true');
  host.style.cssText = 'position:fixed!important;left:-10000px!important;top:-10000px!important;width:1px!important;height:1px!important;overflow:hidden!important;opacity:0!important;pointer-events:none!important;';
  const name = customer.name || [customer.firstName,customer.lastName].filter(Boolean).join(' ');
  host.textContent = `${name || ''} VIN ${customer.vin || ''}`;
  document.body.appendChild(host);

  try {
    let action = null;
    for (let i=0;i<25;i+=1) {
      action = host.querySelector('.vc-print-pack-action');
      if (action) break;
      await wait(80);
    }
    if (!action) throw new Error('Print Pack is not ready yet. Please try again.');
    action.click();
    await wait(150);
    if (mode === 'esign') {
      for (let i=0;i<20;i+=1) {
        const eSign = document.querySelector('.vc-pp-esign');
        if (eSign) { eSign.click(); break; }
        await wait(100);
      }
    }
  } catch (error) {
    window.alert(error.message || 'Unable to open Print Pack.');
  } finally {
    host.remove();
    busy = false;
  }
};

window.addEventListener('vincentrix:open-print-pack', event => openPack(event.detail));
export {};
